import { RootState } from '@/redux';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from "react-router-dom"
import { useSelector } from 'react-redux'

export const Router = () => {
  const { userData } = useSelector((state: RootState) => state.user)
  const navigate = useNavigate()
  const [cookies, ] = useCookies(['tcsAccessToken', 'tcsRefreshToken'])

  useEffect(() => { 
    if (!cookies.tcsAccessToken && !cookies.tcsRefreshToken) { 
      navigate('/login')
    }
    if (userData?.isTCSAdmin) {
      navigate('/tcs200')
    } else if (userData?.isTCSAdmin === false) {
      navigate('/workflows')
    } else { 
      navigate('/router')
    }
  }, [cookies, userData, navigate])

  return (
    <div>Securely processing your request...</div>
  )
};
